import React, { useState, useEffect } from 'react';
import { Card, Button, Table, Badge, Spinner, Modal, Form } from 'react-bootstrap';
import { useQuery, useQueryClient } from 'react-query';
import { DUYET_HOIDONGDAODUC_API, BaseGatewayImage } from '@app/utils/apiUrl';
import { trangThaiHDDDValue } from '@app/utils/define';
import { Get, Put } from '@app/utils/httpProvider';
import moment from 'moment';
import { toast } from 'react-toastify';
import HoiDongDaoDucEdit from './HoiDongDaoDucEdit';
import HoiDongDaoDucAdd from './HoiDongDaoDucAdd';

const DuyetHoiDongDaoDuc = ({ hoSoId }) => {
    const queryClient = useQueryClient();
    const [showModal, setShowModal] = useState(false);
    const [viewMode, setViewMode] = useState('list');
    const [modalMode, setModalMode] = useState('');
    const [dataEdit, setDataEdit] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [trangThai, setTrangThai] = useState('');
    const [ghiChu, setGhiChu] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    const { isLoading, data: queryData, refetch } = useQuery(
        ['duyetHoiDongDaoDucData', hoSoId],
        () => Get(DUYET_HOIDONGDAODUC_API.GET_PAGING, null, { HoSoNghienCuuSinhId: hoSoId, PageIndex: 1, PageSize: 100 }),
        { 
            enabled: !!hoSoId,
            keepPreviousData: true
        }
    );

    let dataList = [];
    if (queryData) {
        if (Array.isArray(queryData)) {
            dataList = queryData;
        } else if (queryData.data && Array.isArray(queryData.data)) {
            dataList = queryData.data;
        } else if (queryData.data?.$values) {
            dataList = queryData.data.$values;
        }
    }

    useEffect(() => {
        if (dataList && dataList.length > 0) {
            setSelectedRow(prev => {
                if (prev) {
                    const fresh = dataList.find(item => item.id === prev.id);
                    return fresh || dataList[0];
                }
                return dataList[0];
            });
        } else {
            setSelectedRow(null);
        }
    }, [dataList]);

    const handleAction = (item, mode) => {
        setDataEdit(item);
        setModalMode(mode);
        setTrangThai(mode);
        setGhiChu(item.ghiChuChinhSua || '');
        setShowModal(true);
    };

    const submitDuyet = async () => {
        if (!trangThai) {
            toast.warning('Vui lòng chọn trạng thái duyệt!');
            return;
        }

        const payload = {
            HoSoNghienCuuSinhId: hoSoId,
            SoQuyetDinh: dataEdit.soQuyetDinh || '',
            NgayCap: dataEdit.ngayCap || null,
            DonViCap: dataEdit.donViCap || '',
            FileHDDD: dataEdit.fileHDDD || '',
            TrangThai: trangThai,
            GhiChuChinhSua: ghiChu
        };

        setIsSaving(true);
        try {
            const res = await Put(DUYET_HOIDONGDAODUC_API.DUYET_HO_SO, dataEdit.id, payload);
            if (res && (res.status === 200 || res.status === 201 || res.status === 204 || res.id || res.success)) {
                toast.success('Lưu thành công!');
                queryClient.invalidateQueries(['hoiDongDaoDucData', hoSoId]);
                refetch();
                setShowModal(false);
            } else {
                toast.error(res?.message || 'Có lỗi xảy ra');
            }
        } catch (error) {
            toast.error(error?.message || 'Có lỗi xảy ra');
        } finally {
            setIsSaving(false);
        }
    };

    const renderTrangThai = (val) => {
        switch (val) {
            case trangThaiHDDDValue.choDuyet: return <Badge variant="warning">Chờ duyệt</Badge>;
            case trangThaiHDDDValue.hoanThanh: return <Badge variant="success">Hoàn thành</Badge>;
            case trangThaiHDDDValue.tuChoi: return <Badge variant="danger">Từ chối</Badge>;
            default: return <Badge variant="secondary">Chưa xác định</Badge>;
        }
    };

    return (
        <>
        <Card className="card-sticky-layout">
            <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="font-weight-bold text-primary m-0">Hội đồng đạo đức</h5>
                    <Button variant="success" size="sm" onClick={() => setViewMode('add')}>
                        <i className="fas fa-plus mr-1"></i> Thêm mới
                    </Button>
                </div>
            </Card.Header>
            <Card.Body className="d-flex flex-column">
                {isLoading ? (
                    <div className="text-center p-5 m-auto">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <>
                        <div className="table-responsive flex-grow-1">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th className="text-center" width="50">STT</th>
                                        <th>Số quyết định</th>
                                        <th className="text-center">Ngày cấp</th>
                                        <th>Đơn vị cấp</th>
                                        <th className="text-center">File đính kèm</th>
                                        <th className="text-center">Trạng thái</th>
                                        <th>Ghi chú</th>
                                    </tr>
                                </thead>
                            <tbody>
                                {dataList.length > 0 ? (
                                    dataList.map((item, index) => (
                                        <tr 
                                            key={item.id}
                                            onClick={() => setSelectedRow(item)}
                                            style={{ cursor: 'pointer' }}
                                            className={selectedRow?.id === item.id ? 'table-primary' : ''}
                                        >
                                            <td className="text-center">{index + 1}</td>
                                            <td>{item.soQuyetDinh}</td>
                                            <td className="text-center">
                                                {item.ngayCap ? moment(item.ngayCap).format('DD/MM/YYYY') : ''}
                                            </td>
                                            <td>{item.donViCap}</td>
                                            <td className="text-center">
                                                {item.fileHDDD ? (
                                                    (() => {
                                                        const path = item.fileHDDD;
                                                        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
                                                        const safePath = path.startsWith('/') ? path : `/${path}`;
                                                        const fileUrl = path.startsWith('http') ? path : `${baseUrl}${safePath}`;
                                                        let name = path.split('/').pop() || 'File';
                                                        name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                                                        return (
                                                            <a href={fileUrl} target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm text-left mb-1 mr-1" style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                                                <i className="fas fa-paperclip mr-1"></i> {name}
                                                            </a>
                                                        );
                                                    })()
                                                ) : (
                                                    <span className="text-muted">Không có</span>
                                                )}
                                            </td>
                                            <td className="text-center">{renderTrangThai(item.trangThai)}</td>
                                            <td>{item.ghiChuChinhSua || ''}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted">
                                            Chưa có dữ liệu Hội đồng đạo đức
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                        </div>
                    </>
                )}
            </Card.Body>
            {!isLoading && (
                <Card.Footer className="bg-white card-footer-sticky">
                    <div className="d-flex justify-content-end pr-4">
                        <Button 
                            variant={selectedRow?.trangThai === trangThaiHDDDValue.hoanThanh ? "success" : "outline-success"} 
                            size="sm" 
                            onClick={() => handleAction(selectedRow, trangThaiHDDDValue.hoanThanh)} 
                            className="mr-2"
                            disabled={!selectedRow}
                        >
                            <i className="fas fa-check mr-1"></i> Duyệt
                        </Button>
                        <Button 
                            variant={selectedRow?.trangThai === trangThaiHDDDValue.tuChoi ? "danger" : "outline-danger"} 
                            size="sm" 
                            onClick={() => handleAction(selectedRow, trangThaiHDDDValue.tuChoi)} 
                            className="mr-2"
                            disabled={!selectedRow}
                        >
                            <i className="fas fa-times mr-1"></i> Từ chối
                        </Button>
                        <Button 
                            variant="info" 
                            size="sm" 
                            onClick={() => { setDataEdit(selectedRow); setViewMode('edit'); }}
                            disabled={!selectedRow}
                        >
                            <i className="fas fa-edit mr-1"></i> Sửa
                        </Button>
                    </div>
                </Card.Footer>
            )}
        </Card>

        {showModal && (
            <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static" keyboard={false} size="md">
                <Modal.Header closeButton className="bg-primary text-white">
                    <Modal.Title>
                        {modalMode === trangThaiHDDDValue.hoanThanh ? 'Duyệt Hội đồng đạo đức' : 'Từ chối duyệt'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Ghi chú {modalMode === trangThaiHDDDValue.tuChoi && <span className="text-danger">*</span>}</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={3} 
                                placeholder={modalMode === trangThaiHDDDValue.tuChoi ? "Nhập lý do từ chối..." : "Nhập ghi chú (nếu có)..."} 
                                value={ghiChu}
                                onChange={(e) => setGhiChu(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)} disabled={isSaving}>
                        Hủy
                    </Button>
                    <Button variant="primary" onClick={submitDuyet} disabled={isSaving || (modalMode === trangThaiHDDDValue.tuChoi && !ghiChu.trim())}>
                        {isSaving ? 'Đang lưu...' : 'Lưu lại'}
                    </Button>
                </Modal.Footer>
            </Modal>
        )}
        
        {viewMode === 'edit' && dataEdit && (
            <HoiDongDaoDucEdit hoSoId={hoSoId} dataEdit={dataEdit} setViewMode={setViewMode} refreshList={refetch} />
        )}
        {viewMode === 'add' && (
            <HoiDongDaoDucAdd hoSoId={hoSoId} setViewMode={setViewMode} refreshList={refetch} />
        )}
        </>
    );
};

export default DuyetHoiDongDaoDuc;
